// Handles both "HH:MM:SS" string (from backend) and plain numbers (seconds)
export const parseDurationToSeconds = (duration) => {
  if (!duration) return 0;
  if (typeof duration === "number") return duration;
  if (typeof duration === "string" && duration.includes(":")) {
    const parts = duration.split(":").map(Number);
    if (parts.some(isNaN)) return 0;
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    if (parts.length === 2) return parts[0] * 60 + parts[1];
  }
  return Number(duration) || 0;
};

export const deriveDurationStatus = (
  started_at,
  completed_at,
  expected_duration,
) => {
  const durationSecs = parseDurationToSeconds(expected_duration);
  if (!started_at || !durationSecs) return null;
  const elapsed =
    ((completed_at ? new Date(completed_at) : new Date()) -
      new Date(started_at)) /
    1000;
  if (completed_at) {
    return elapsed <= durationSecs ? "COMPLETED_WITHIN_TIME" : "OVERDUE";
  }
  return elapsed <= durationSecs ? "ON_TRACK" : "OVERDUE";
};
